import React from 'react'
import './Earphones.css'
import { useNavigate} from 'react-router-dom';
function Earphones({setEarphones}) {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/');
    setEarphones(false);
  }
  return (
      <div className="postcard Earphones">
        <button style={{margin: '0px -12px'}}onClick={handleClose}>Close</button>
        <h1 style={{marginLeft: '35%'}}>Music Recs</h1>
        <div className="music">
          <div className="row">
            <div className="col-sm mx-2 p-0">
            <iframe title="brambles" style={{'borderRadius':'12px'}} src="https://open.spotify.com/embed/track/2sHWoU97dgQfATRm99WFzr?utm_source=generator&theme=0" width="100%" height="200" frameBorder="0" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
            </div>
            <div className="col-sm mx-2 p-0">
            <iframe title="ye-dunya" style={{'borderRadius':'12px'}} src="https://open.spotify.com/embed/track/3CLlelB1UWvrGYCyvdAA4B?utm_source=generator&theme=0" width="100%" height="200" frameBorder="0" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
            </div>
            <div className="col-sm mx-2 p-0">
            <iframe title='you-should-see-me-in-a-crown' style={{'borderRadius':'12px'}} src="https://open.spotify.com/embed/track/3XF5xLJHOQQRbWya6hBp7d?utm_source=generator&theme=0" width="100%" height="200" frameBorder="0" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>            </div>
          </div>
          <div className="row">
            <div className="col-sm mx-2 p-0">
            <iframe title='ek-nagma' style={{'borderRadius':'12px'}} src="https://open.spotify.com/embed/track/0wAIffslRgmzF0ktjHP7jB?utm_source=generator&theme=0" width="100%" height="200" frameBorder="0" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
            </div>
            <div className="col-sm mx-2 p-0">
            <iframe title="flashing-lights" style={{'borderRadius':'12px'}} src="https://open.spotify.com/embed/track/5TRPicyLGbAF2LGBFbHGvO?utm_source=generator&theme=0" width="100%" height="200" frameBorder="0" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
            </div>
            <div className="col-sm mx-2 p-0">
            <iframe title='redesign' style={{'borderRadius':'12px'}} src="https://open.spotify.com/embed/track/6L1V0LvpXBJ7QptKuLUj3v?utm_source=generator&theme=0" width="100%" height="200" frameBorder="0" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>            </div>
          </div>
          <div className="row">
            <div className="col-sm mx-2 p-0">
            <iframe title="moon-song" style={{'borderRadius':'12px'}} src="https://open.spotify.com/embed/track/46RNrAkGsqWTDrv2ZPOAbx?utm_source=generator&theme=0" width="100%" height="200" frameBorder="0" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
            </div>
            <div className="col-sm mx-2 p-0">
            <iframe title="all-alone" style={{'borderRadius':'12px'}} src="https://open.spotify.com/embed/track/72xnRXxHiAhTfKSzlPdEmo?utm_source=generator&theme=0" width="100%" height="200" frameBorder="0" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
            </div>
            <div className="col-sm mx-2 p-0">
            <iframe title='superposition' style={{'borderRadius':'12px'}} src="https://open.spotify.com/embed/track/67YPjbcxUypwNOwYBZquq1?utm_source=generator&theme=0" width="100%" height="200" frameBorder="0" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>            </div>
          </div>
        </div>
        
      </div>
  )
}

export default Earphones

